/**
 * Insider Integration — Type Definitions
 * Aligned with ecom.storefront InsiderQueue pattern.
 */

/** Customer profile data collected from the registration form */
export interface InsiderCustomerProfile {
  cpf: string;
  nome: string;
  email: string;
  telefone: string;
  dataNascimento: string;
  genero: string;
  cidade: string;
  estado: string; // Nome completo do estado (ex: "São Paulo")
  email_optin?: boolean;
  sms_optin?: boolean;
  whatsapp_optin?:boolean;
  gdpr_optin?:boolean;
  consentTerms: boolean;
  consentNotification: boolean;
}

/** Event parameters for campaign-voucher_registration */
export interface RegistrationEventParams {
  cpf_hash: string;
  campaign_name: string;
  consent_terms: boolean;
  consent_notification: boolean;
}

/** Event parameters for campaign-voucher_reservation */
export interface ReservationEventParams {
  voucher_id: string;
  reservation_date: string;
  redemption_date: string;
  redemption_datetime: string;
  store_code: string;
  store_name: string;
  campaign_name: string;
}

/** Event parameters for campaign-voucher_redemption (Store frontend) */
export interface RedemptionEventParams {
  cpf: string;
  voucher_id: string;
  reservation_date: string;
  store_code: string;
  store_name: string;
  campaign_name: string;
}

/** Insider Queue item types (same pattern as storefront) */
export enum EInsiderQueueType {
  init = 'init',
  user = 'user',
  currency = 'currency',
  custom_event = 'custom_event',
  set_custom_identifier = 'set_custom_identifier',
}

export interface IInsiderQueueBase {
  type: EInsiderQueueType;
  value?: unknown;
}

declare global {
  interface Window {
    InsiderQueue: IInsiderQueueBase[];
  }
}
